// @flow
import { connect } from 'react-redux'
import mapComponent from './component'
import { mapActiveMunicipality } from './reducer'

function mapDispatchToProps (dispatch) {
  return {
    mouseOverHandler: id => {
      if (!isNaN(id) && id < 9000) {
        dispatch(mapActiveMunicipality(id))
      }
    }
  }
}

export const Map = connect(null, mapDispatchToProps)(mapComponent)

export default Map



// WEBPACK FOOTER //
// ./src/components/map/container.js